import { State } from "./State";
export class Player {
    constructor(id, identityOverride, name, pictureId, roomId) {
        this.id = id;
        this.identityOverride = new State(identityOverride);
        this.name = new State(name);
        this.pictureId = new State(pictureId);
        this.roomId = new State(roomId);
    }
    toJSON() {
        return {
            id: this.id,
            identityOverride: this.identityOverride.value,
            name: this.name.value,
            pictureId: this.pictureId.value,
            roomId: this.roomId.value,
        };
    }
}
